var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.activeTags.length
  )?_c('div',{staticClass:"filter-tags"},[_vm._l((_vm.visibleTags),function(tag){return _c('el-tag',{key:tag,class:{
      'tag-disabled': _vm.disabled
    },attrs:{"type":"sc-asset","closable":tag !== 'date' && !_vm.disabled},on:{"click":() => _vm.clickTag(tag),"close":() => _vm.removeTag(tag)}},[_vm._v("\n    "+_vm._s(_vm.label(tag))+"\n  ")])}),_vm._v(" "),(
      _vm.hasOverflow
    )?_c('el-tag',{class:{
      'tag-disabled': _vm.disabled
    },attrs:{"type":"sc-asset","closable":false},on:{"click":() => _vm.clickTag(null)}},[_vm._v("\n    อื่นๆ ("+_vm._s(_vm.overflowCount)+")\n  ")]):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }